/**
 * Servicio que se encarga del manejo de las peticiones sobre las Alertas de las PQR.
 * JMM-2018-07-18
 */
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service';

@Injectable()
export class AlertapqrService {

  public alertaspqrs : any[] = [];
  PATH = new ConfigService().obtenerPath();

  constructor(
    private http  : Http,
    private _key  : KeyService
  ) {}

   /**
   * Obtener el listado completo de las Alertas PQR
   * JMM-2018-07-18
   */
  getAlertasPqrs(){
    let url = this.PATH + '/api/public/alertapqr';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getAlertasPqrs()

  /**
   * Obtener un registro por id de una Alerta PQR para editar
   * JMM-2018-07-18
   */
  getRegAlertaPqr(id:any)
  {
    let url = this.PATH + '/api/public/registroalertapqr/' + id;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getRegAlertaPqr(id:any)

  /**
   * Enviar registro de una Alerta PQR a Guardar en bd
   * JMM-2018-07-18
   */
  setAlertaPqr(alertapqr:any)
  {
    let url = this.PATH + '/api/public/alertapqr';
    return this.http.post(url, alertapqr, {headers:this._key.head()}).map(resp => resp.json());
  }// .setAlertaPqr(alertapqr:any)

  /**
   * Editar registro de Alerta PQR en bd
   * JMM-2018-07-18
   */
  editAlertaPqr(alertapqr:any)
  {
    let url = this.PATH+'/api/public/alertapqr/'+alertapqr.pqrid;
    return this.http.put(url, alertapqr, {headers:this._key.head()}).map( resp => resp.json());
  }// .editAlertaPqr(alertapqr:any)

  /**
   * Obtener el listado de alertas correspondientes a un usuario
   * JMM-2018-12-17
   */
  getlistadoalertas(data:any)
  {
    let url = this.PATH + '/api/public/listadoalertas';
    return this.http.post(url,data, {headers:this._key.head()}).map(resp => resp.json());
  }// .getlistadoalertas(idusuario:any)

  validaUsuario(idusuario){
    let url = this.PATH + '/api/public/validaUsuario/'+idusuario;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getAlertasPqrs()


  updatePassword(data){
    let url = this.PATH + '/api/public/updatePassword';
    return this.http.post(url,data,{headers:this._key.head()}).map(resp => resp.json());
  }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/pqr/alertapqr.service.ts